// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3qjfy","col":"Table_col__2N8K-","fulfillmentStatus":"Table_fulfillmentStatus__2HeST","emailCol":"Table_emailCol__2YCa4"};